import { getAvailableSheetList } from "@/utils/sheet"
import { bfs } from "@/utils/algorithm"

export default {
  filters: {
    translateAllSheet(allSheet) {
      if (allSheet.length <= 0) return []
      return allSheet.map(i => ({ label: i.name, value: i.sheetId }))
    },
    translateSheetFields(sheetInfo) {
      if (!sheetInfo.controls || sheetInfo.controls.length <= 0) return []
      return sheetInfo.controls.map(i => ({ label: i.name, value: i._cid }))
    },
    translateSheetFieldsSub(sheetInfo, controlTypeMap) {
      if (!sheetInfo.controls || sheetInfo.controls.length <= 0) return []
      return sheetInfo.controls
        .concat([
          { name: "创建人", _cid: "cid", _type: "staff" },
          { name: "负责人", _cid: "oid", _type: "staff" },
          { name: "最后修改人", _cid: "upid", _type: "staff" },
          { name: "创建时间", _cid: "cat", _type: "time" },
          { name: "最后修改时间", _cid: "uat", _type: "time" }
        ])
        .reduce((acc, cur) => {
          const typeName = controlTypeMap?.[cur._type]?.name
          acc.push({ label: "[" + typeName + "] " + cur.name, value: cur._cid })
          return acc
        }, [])
    },
    screenTimeField(sheetInfo) {
      if (!sheetInfo.controls || sheetInfo.controls.length <= 0) return []
      let output = []
      sheetInfo.controls.forEach(i => {
        if (["date", "time"].includes(i._type)) {
          output.push({
            label: (i._type == "date" ? "[日期] " : "[日期时间] ") + i.name,
            value: i._cid,
            type: i._type
          })
        }
      })
      return output.concat([
        {
          label: "[日期时间] 创建时间",
          value: "cat",
          type: "time"
        },
        {
          label: "[日期时间] 更新时间",
          value: "uat",
          type: "time"
        }
      ])
    },
    translateAllRoles(allRoles) {
      if (!allRoles || allRoles.length <= 0) return []
      return allRoles.map(i => ({ label: i.name, value: i.id }))
    },
    // 从当前工作流关联的数据筛选出人员,如果是邮箱通知则包含邮件控件
    screenPeople(flowConnectedData, isMail = false) {
      if (!flowConnectedData || flowConnectedData.length <= 0) return []
      let people = []
      let matched = []
      bfs({
        cloneDeep: false,
        arr: flowConnectedData,
        childFuc: varGroup => varGroup.groups,
        cbk: varGroup => {
          varGroup.vars
            .filter(v => v.control._type === "staff" || (isMail && v.control._type === "mail"))
            .forEach(v => {
              if (varGroup._deep === 0) {
                matched.push({
                  label: `[${varGroup.name}] ${v.name}`,
                  value: v.expresion,
                  parent: varGroup.name,
                  isMail: isMail && v.control._type === "mail"
                })
              } else {
                matched.push({
                  label: `[${varGroup.name}] ${v.name}`,
                  value: v.expresion,
                  parent: varGroup._parent.name,
                  isMail: isMail && v.control._type === "mail"
                })
              }
            })
        }
      })
      let map = {}
      matched.forEach(m => {
        if (!map[m.parent]) {
          map[m.parent] = [m]
        } else {
          map[m.parent].push(m)
        }
      })
      Object.keys(map).forEach(key => {
        people.push({
          label: key,
          options: map[key]
        })
      })
      return people
    },
    // 根据变量传入类型(control type)获取可选值列表
    getValListByType(type) {
      let valList = []
      switch (type) {
        case "time":
        case "date": {
          valList = [
            {
              label: "指定时间",
              value: "指定时间"
            },
            {
              label: "系统当前时间",
              value: "NOW"
            }
          ]
          break
        }
      }
      return valList
    },
    // 将 availableSheets 转成分组列表
    translateAvailableSheets(availableSheets) {
      if (!availableSheets || availableSheets.length == 0) return []
      return getAvailableSheetList(availableSheets)
    }
  }
}
